import React, { useState } from 'react';
import { MdOutlineSpa } from "react-icons/md";

import images from '../../constants/images';

import './Navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = React.useState(false);
  return (

    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.divinenail} alt="app logo" />
      </div>
      <ul className="app__navbar-links">
        <li className="p__opensans"><a href="#home"> Home </a></li>
        <li className="p__opensans"><a href="#contact"> Contact </a></li>
        <li className="p__opensans"><a href="#about"> Info </a></li>
        <li className="p__opensans"><a href="#service"> Services </a></li>
        <li className="p__opensans"><a href="#technician"> Technicians </a></li>

      </ul>
      <div className="app__navbar-book">
        <a href="#login" className="p__opensans">Book Appointment</a>
        <div />
      
      </div>
      <div className='app__navbar-smallscreen'>

        {toggleMenu && (
          <div className='app__navbar-smallscreen_overlay flex__center slide-bottom'>
            <MdOutlineSpa fontSize={27} className='overlay__close' onClick={() => setToggleMenu(false)} />
            <ul className="app__navbar-smallscreen_links">
              <li className="p__opensans"><a href="#home"> Home </a></li>
              <li className="p__opensans"><a href="#contact"> Contact </a></li>
              <li className="p__opensans"><a href="#about"> Info </a></li>
              <li className="p__opensans"><a href="#service"> Services </a></li>
              <li className="p__opensans"><a href="#technician"> Technicians </a></li>
         
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
